import script from "./ODetalhesUsuario.vue?vue&type=script&lang=ts&setup=true"
export * from "./ODetalhesUsuario.vue?vue&type=script&lang=ts&setup=true"

import "./ODetalhesUsuario.vue?vue&type=style&index=0&id=b50f0cb8&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b50f0cb8"]])

export default __exports__